<div class="link" (click)="showModal()">{{'patients.patient_careplans.multiple_plans' | translate}}</div>
<ng-container *ngIf="careplans">
  <p-dialog
    [header]="'patients.patient_careplans.care_plan_details' | translate"
    [(visible)]="modalActive"
    [modal]="true"
    [style]="{width: '400px'}"
    [baseZIndex]="10000"
    [draggable]="false"
    [resizable]="false"
  >
    <div class="dialog-content">
      <ng-container *ngFor="let item of careplans">
        <p class="careplan-item">{{ item }}</p>
      </ng-container>
    </div>
  </p-dialog>
</ng-container>
